import { setFilter } from './actions/filter'
import { setPage } from './actions/page'
import { fetchPosts } from './actions/posts'

/**
 * Updates browser URL to current page.
 *
 * @param {integer} page The current page.
 * @return {string} The URL.
 */
function addPageToURL(page) {
	var url = `${window.location.href.replace(/page(\/[0-9]*\/?)?$/i, '')}page/${page}`;

	if (page === 1) {
		url = `${window.location.href.replace(/page(\/[0-9]*\/?)?$/i, '')}`;
	}

	return url;
}

export function pushStateChange(dispatch, getState) {
	let appState = getState();

	let filter = appState.filter;
	let page = appState.page;
	let pushState = {filter, page};

	window.history.pushState(pushState, '', addPageToURL(page.page));
}

export function replaceState(appState) {
	let filter = appState.filter;
	let page = appState.page;
	let pushState = {filter, page};

	window.history.replaceState(pushState, '', addPageToURL(page.page));
}

export function popState(state, dispatch) {
	dispatch(setFilter(state.filter));
	dispatch(setPage(state.page.page));
	dispatch(fetchPosts());
}



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/history.js